import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const CHECK_EMAIL = gql`
  query checkEmail($email: String!) {
    checkEmail(email: $email) {
      exists
    }
  }
`;
const useCheckEmailExists = () =>
  useCallback(async (variables) => {
    try {
      const {
        data: {
          checkEmail: { exists },
        },
      } = await subscriptionsPublicClient.query({
        query: CHECK_EMAIL,
        variables: variables,
      });

      return exists;
    } catch (e) {
      window.newrelic?.noticeError?.(new Error(e));
    }
  }, []);

export default useCheckEmailExists;
